"use client";

import React from "react";
import { HiOutlineExclamationCircle } from "react-icons/hi2";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import ReactModal from "react-modal";
const Modal = ReactModal as any;

interface RejectModalProps {
	loading?: boolean;
	isOpen: boolean;
	onRequestClose: () => void;
	onConfirm: () => void;
	messageH: string;
	message: string;
}

export default function RejectModal({
	loading,
	isOpen,
	onRequestClose,
	onConfirm,
	messageH,
	message,
}: RejectModalProps) {
	const { t } = useTranslation();

	return (
		<Modal
			isOpen={isOpen}
			style={isOpen ? customStyles : closingStyles}
			contentLabel="Confirm Dialog"
			closeTimeoutMS={300}
			ariaHideApp={false}
		>
			<div>
				<div className="bg-white py-6 px-2 md:px-8">
					<div className="flex justify-start items-start gap-3 md:gap-5">
						<div className="bg-[#FEF3C7] p-1 md:p-2 rounded-full">
							<HiOutlineExclamationCircle
								size={24}
								className="text-[#D97706]"
							/>
						</div>
						<div className="flex flex-col gap-3 text-[#383838]">
							<p className="text-option">{message}</p>
							<p className="text-optional">{messageH}</p>
						</div>
					</div>
				</div>

				<div className="flex justify-end gap-x-3 bg-[#F6F6F6] p-4">
					<button
						onClick={onRequestClose}
						className="rounded-lg border-[1px] py-2.5 px-4 border-[#B9B9B9] bg-white text-optional text-[#383838] hover:bg-[#B9B9B9] transition flex items-center"
					>
						{t("cancel")}
					</button>

					<button
						onClick={onConfirm}
						disabled={loading}
						className={`rounded-lg py-1 px-4 text-white flex items-center justify-center gap-1 text-optional transition ${loading
							? "bg-primary cursor-not-allowed"
							: "bg-primary hover:bg-primary"
							}`}
					>
						{loading ? (
							<>
								<AiOutlineLoading3Quarters
									size={14}
									className="animate-spin"
								/>
								{t("confirm")}
							</>
						) : (
							t("confirm")
						)}
					</button>
				</div>
			</div>
		</Modal>
	);
}

const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		transition: "opacity 300ms ease-in-out",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 999999,
	},
	content: {
		top: "20%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		transform: "translate(-50%, -50%)",
		transition: "transform 300ms ease-in-out, opacity 300ms ease-in-out",
		padding: "",
		borderRadius: "12px",
		border: "none",
		width: "95%",
		maxWidth: "640px",
		backgroundColor: "white",
	},
};

const closingStyles = {
	overlay: {
		...customStyles.overlay,
		opacity: 0,
	},
	content: {
		...customStyles.content,
		opacity: 0,
		transform: "translate(-50%, -40%)",
	},
};
